import { useCallback } from 'react';
import { useRxData } from 'rxdb-hooks';

import { RxdbCollectionName } from '../rxdbCollectionName';
import type {
  DeficiencyActionedList,
  DeficiencyActionedListCollection,
} from './deficiencyActionedList.types';

const useDeficiencyActionedList = (assetId: number) => {
  const getDeficiencyActionedListQuery = useCallback(
    (collection: DeficiencyActionedListCollection) =>
      collection?.find({
        selector: {
          $and: [{ assetId }],
        },
      }),
    [assetId],
  );

  const { result: deficiencyActionedList } = useRxData<DeficiencyActionedList>(
    RxdbCollectionName.DEFICIENCY_ACTIONED_LIST,
    getDeficiencyActionedListQuery,
    { json: true },
  );

  return { deficiencyActionedList };
};

export default useDeficiencyActionedList;
